// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import qs from 'qs'

import ElementUI from 'element-ui';
import './assets/style/base.css'
import 'element-ui/lib/theme-chalk/index.css';
import { VueJsonp } from 'vue-jsonp'    // 有时候不加{}，会报错
import VueClipboard from 'vue-clipboard2'    // 引入

import moment from 'moment'     //日期时间转换
import axios from "./api/api";

import '@/assets/iconfont/iconfont.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// import Base64 from 'js-base64'
// Vue.use(Base64)
const Base64 = require('js-base64').Base64

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;//请求接口api

Vue.use(ElementUI,VueJsonp,VueClipboard);
 
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": false, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

Vue.prototype.$qs = qs
Vue.config.productionTip = false
new Vue({
  // 指定要渲染的元素
  el: '#app',
  // 路由配置
  router,
  // 状态管理
  store,
  // Base64编码解码
  Base64,
  // 组件
  components: { App },
  // 模板
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js